import { vec3, vec4, vec2 } from 'gl-matrix';

export function uuid() {
  // Credits: Broofa @ https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523

  // Note: getRandomValues is significantly slower than Math.random so only use that when security is a concern
  // in the case of this engine the uuids are used for identifying objects.
  //return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
  //	var r = crypto.getRandomValues(new Uint8Array(1))[0]%16|0, v = c == 'x' ? r : (r&0x3|0x8);
  //	return v.toString(16);
  //});

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function vectorMin(
  size: number,
  vectors: vec2[] | vec3[] | vec4[] | number[][],
): vec2 | vec3 | vec4 {
  let min: number[] = [];
  for (let i = 0; i < size; i++) {
    min.push(Infinity);
  }

  for (let i = 0; i < vectors.length; i++) {
    for (let e = 0; e < size; e++) {
      if (vectors[i][e] < min[e]) {
        min[e] = vectors[i][e];
      }
    }
  }

  return min;
}

export function vectorMax(
  size: number,
  vectors: vec2[] | vec3[] | vec4[] | number[][],
): vec2 | vec3 | vec4 {
  let max: number[] = [];
  for (let i = 0; i < size; i++) {
    max.push(-Infinity);
  }

  for (let i = 0; i < vectors.length; i++) {
    for (let e = 0; e < size; e++) {
      if (vectors[i][e] > max[e]) {
        max[e] = vectors[i][e];
      }
    }
  }

  return max;
}

export function lerp(a: number, b: number, progress: number) {
  return a * (1 - progress) + b * progress;
}
